import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, showToast, useUIActions } from "../../../../../features/ui"
import { useServer } from "../../../../../services/server"
import { FiscalDocument } from "../../../../fiscal-documents"

export const useActions = (onRefresh?: () => Promise<void>) => {
    const { annulFiscalDocument: annulRequest } = useServer()

    const { closeModal } = useUIActions()

    const annulInvoice = async (fiscalDocument: FiscalDocument) => {
        Emitter.emit(Event.DB_SUBMIT, 'Generando nota de crédito por el total...')

        try {
            await annulRequest(fiscalDocument.id)
            await onRefresh?.()

            closeModal(ModalId.SPINNER)
            // La emisión es asíncrona: la factura queda anulada recién cuando la NC se autoriza.
            showToast('Nota de crédito por el total enviada a facturar.')
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo anular la factura.')
        }
    }

    return {
        annulInvoice
    }
}
